import { Components, Theme } from "@mui/material";
import { InternalThemeConfig } from "./config";
import MuiAccordion from "./muiOverrides/accordion";
import MuiAccordionActions from "./muiOverrides/accordionActions";
import MuiAccordionDetails from "./muiOverrides/accordionDetails";
import MuiAccordionSummary from "./muiOverrides/accordionSummary";
import MuiAlert from "./muiOverrides/alert";
import MuiBadge from "./muiOverrides/badge";
import MuiButton from "./muiOverrides/button";
import MuiButtonBase from "./muiOverrides/buttonBase";
import MuiButtonGroup from "./muiOverrides/buttonGroup";
import MuiCard from "./muiOverrides/card";
import MuiCardActionArea from "./muiOverrides/cardActionArea";
import MuiCircularProgress from "./muiOverrides/circularProgress";
import MuiCheckbox from "./muiOverrides/checkbox";
import MuiChip from "./muiOverrides/chip";
import MuiDialog from "./muiOverrides/dialog";
import MuiDialogActions from "./muiOverrides/dialogActions";
import MuiDialogContent from "./muiOverrides/dialogContent";
import MuiDialogTitle from "./muiOverrides/dialogTitle";
import MuiFormControl from "./muiOverrides/formControl";
import MuiFormControlLabel from "./muiOverrides/formControlLabel";
import MuiFormHelperText from "./muiOverrides/formHelperText";
import MuiIconButton from "./muiOverrides/iconButton";
import MuiInput from "./muiOverrides/input";
import MuiOutlinedInput from "./muiOverrides/outlinedInput";
import MuiInputLabel from "./muiOverrides/inputLabel";
import MuiInputBase from "./muiOverrides/inputBase";
import MuiListItem from "./muiOverrides/listItem";
import MuiListItemIcon from "./muiOverrides/listItemIcon";
import MuiListSubheader from "./muiOverrides/listSubheader";
import MuiMobileStepper from "./muiOverrides/mobileStepper";
import MuiTablePagination from "./muiOverrides/pagination";
import MuiPaper from "./muiOverrides/paper";
import MuiRadio from "./muiOverrides/radio";
import MuiSlider from "./muiOverrides/slider";
import MuiSwitch from "./muiOverrides/switch";
import MuiSvgIcon from "./muiOverrides/svgIcon";
import MuiTab from "./muiOverrides/tab";
import MuiTableCell from "./muiOverrides/tableCell";
import MuiTableRow from "./muiOverrides/tableRow";
import MuiTabs from "./muiOverrides/tabs";
import MuiTextField from "./muiOverrides/textField";
import MuiToggleButton from "./muiOverrides/toggleButton";
import MuiTooltip from "./muiOverrides/tooltip";
import MuiTypography from "./muiOverrides/typography";

const overrides = (config: InternalThemeConfig): Components<Theme> => ({
  MuiAccordion: {
    styleOverrides: MuiAccordion(config),
  },
  MuiAccordionActions: {
    styleOverrides: MuiAccordionActions(config),
  },
  MuiAccordionDetails: {
    styleOverrides: MuiAccordionDetails(config),
  },
  MuiAccordionSummary: {
    styleOverrides: MuiAccordionSummary(config),
  },
  MuiAlert: {
    styleOverrides: MuiAlert(config),
  },
  MuiButtonBase: {
    styleOverrides: MuiButtonBase(),
  },
  MuiBadge: {
    styleOverrides: MuiBadge(),
  },
  MuiButton: {
    styleOverrides: MuiButton(config),
  },
  MuiButtonGroup: {
    styleOverrides: MuiButtonGroup(config),
  },
  MuiCard: {
    styleOverrides: MuiCard(config),
  },
  // MuiCardContent,
  // MuiCardActions,
  MuiCardActionArea: {
    styleOverrides: MuiCardActionArea(),
  },
  MuiCircularProgress: {
    styleOverrides: MuiCircularProgress(),
  },
  MuiCheckbox: {
    styleOverrides: MuiCheckbox(config),
  },
  MuiChip: {
    styleOverrides: MuiChip(config),
  },
  MuiDialog: {
    styleOverrides: MuiDialog(),
  },
  MuiDialogActions: {
    styleOverrides: MuiDialogActions(),
  },
  MuiDialogContent: {
    styleOverrides: MuiDialogContent(),
  },
  MuiDialogTitle: {
    styleOverrides: MuiDialogTitle(config),
  },
  // MuiDivider,
  MuiFormControl: {
    styleOverrides: MuiFormControl(config),
  },
  MuiFormControlLabel: {
    styleOverrides: MuiFormControlLabel(config),
  },
  MuiFormHelperText: {
    styleOverrides: MuiFormHelperText(config),
  },
  MuiIconButton: {
    styleOverrides: MuiIconButton(config),
  },
  // MuiInputAdornment,
  MuiInput: {
    styleOverrides: MuiInput(config),
  },
  MuiOutlinedInput: {
    styleOverrides: MuiOutlinedInput(config),
  },
  MuiInputBase: {
    styleOverrides: MuiInputBase(),
  },
  MuiInputLabel: {
    styleOverrides: MuiInputLabel(config),
  },
  MuiListItem: {
    styleOverrides: MuiListItem(config),
  },
  MuiListItemIcon: {
    styleOverrides: MuiListItemIcon(config),
  },
  MuiListSubheader: {
    styleOverrides: MuiListSubheader(config),
  },
  MuiMobileStepper: {
    styleOverrides: MuiMobileStepper(config),
  },
  MuiPagination: {
    styleOverrides: MuiTablePagination(config),
  },
  MuiPaper: {
    styleOverrides: MuiPaper(config),
  },
  // MuiPickersCalendarHeader: {
  //    styleOverrides: MuiPickersCalendarHeader(config),
  // },
  // MuiPickersDay: {
  //    styleOverrides: MuiPickersDay(config),
  // },
  MuiRadio: {
    styleOverrides: MuiRadio(config),
  },
  // MuiSelect,
  MuiSlider: {
    styleOverrides: MuiSlider(config),
  },
  MuiSwitch: {
    styleOverrides: MuiSwitch(config),
  },
  MuiSvgIcon: {
    styleOverrides: MuiSvgIcon(),
  },
  MuiTableCell: {
    styleOverrides: MuiTableCell(config),
  },
  MuiTableRow: {
    styleOverrides: MuiTableRow(config),
  },
  MuiTab: {
    styleOverrides: MuiTab(config),
  },
  MuiTabs: {
    styleOverrides: MuiTabs(config),
  },
  MuiTextField: {
    styleOverrides: MuiTextField(config),
  },
  MuiToggleButton: {
    styleOverrides: MuiToggleButton(config),
  },
  MuiTooltip: {
    styleOverrides: MuiTooltip(config),
  },
  // MuiTouchRipple,
  MuiTypography: {
    styleOverrides: MuiTypography(config),
  },
});

export default overrides;
